<template>

  <section class="o-container py-20">
    <h1 class="text-[48px] text-blue">{{ $t('finished.title') }}</h1>
    <h2 class="text-[21px] font-semibold font-standout">{{ $t('finished.subtitle') }}</h2>

    <div class="o-panel" v-html="panelText()">
    </div>
  </section>
</template>

<style lang="scss" scoped>
a {
  color: var(--color-blue);
  font-weight: 600;
;
}

.o-panel {
  font-size: 1.7rem;
  max-width: 625px;
  @apply mt-4;

  ::v-deep a {
    @apply text-blue font-semibold;
  }

  ::v-deep h3 {
    @apply font-standout font-semibold;
    @apply mt-10;

    &:first-child {
      margin-top: 0;
    }
  }

}
</style>

<script setup>
import { marked } from 'marked';
import { useI18n } from 'vue-i18n';

const i18n = useI18n();
   const renderer = new marked.Renderer();

    renderer.link = function(href, title, text) {
        // Add rel="noopener" for security best practice
        const titleAttr = title ? ` title="${title}"` : '';
        return `<a href="${href}"${titleAttr} target="_blank" rel="noopener">${text}</a>`;
    };

    marked.setOptions({ renderer });

const panelText = () => {
  return marked.parse(i18n.t('finished.panelText'));
}
</script>